import { type FC } from "react";
import {
  Placeholder,
  PlaceholderHeader,
  PlaceholderLine,
  PlaceholderParagraph,
  Modal as SemanticModal,
} from "semantic-ui-react";
import { Button } from "components/buttons/button/Button";
import cn from "classnames";
import ModalHeader from "../header/ModalHeader";
import "./confirmationModalBase.scss";
import { type ConfirmationModalBaseProps } from "./types";

const loadingContent = () => {
  return (
    <Placeholder>
      <PlaceholderHeader>
        <PlaceholderLine />
        <PlaceholderLine />
        <PlaceholderLine />
      </PlaceholderHeader>
      <PlaceholderParagraph>
        <PlaceholderLine />
        <PlaceholderLine />
        <PlaceholderLine />
        <PlaceholderLine />
        <PlaceholderLine />
      </PlaceholderParagraph>
      <PlaceholderHeader>
        <PlaceholderLine />
        <PlaceholderLine />
      </PlaceholderHeader>
    </Placeholder>
  );
};

const ConfirmationModalBase: FC<ConfirmationModalBaseProps> = (props: ConfirmationModalBaseProps) => {
  const { title, banner, cancelButtonLabel, confirmButtonLabel, isOpen, disabled, loading, ...functionsFromProps } =
    props;
  const { onClose, onCancel, onConfirm, ...otherProps } = functionsFromProps;
  const { size, scrolling, content, actionButtons, styles, classNames } = otherProps;

  const modalClassNames = cn("modal-wrapper", "confirmation-modal-base", styles?.root, classNames);
  return (
    <SemanticModal role="dialog" open={isOpen} className={cn(modalClassNames)} size={size}>
      <SemanticModal.Header>
        <ModalHeader title={title} onClose={onClose} loading={loading} />
      </SemanticModal.Header>
      {banner}
      <SemanticModal.Content className={cn(styles?.content)} scrolling={scrolling ?? true}>
        {loading ? loadingContent() : content}
      </SemanticModal.Content>
      <SemanticModal.Actions>
        {actionButtons || (
          <>
            <Button
              className={"cancel"}
              onClick={onCancel}
              basic
              color="blue"
              content={cancelButtonLabel || "Cancel"}
            />
            {confirmButtonLabel !== null && (
              <Button
                className={"ok"}
                onClick={onConfirm}
                primary
                disabled={disabled}
                content={confirmButtonLabel || "OK"}
              />
            )}
          </>
        )}
      </SemanticModal.Actions>
    </SemanticModal>
  );
};

export default ConfirmationModalBase;
